<template>
  <v-layout>
    <div class="padding-container-lg">
      <!-- <v-page-header>
        <span slot="header">
          <div class="row">
            <div class="col-lg-6">
              Profile
            </div>
          </div>
        </span>
      </v-page-header> -->
      <div>
         <h5>User Deatils</h5>
          <hr/>
        <form @submit.prevent="validateBeforeSubmit">
          <div>
            <div class="row">
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label>First Name</label>
                  <b-form-input
                    v-model="user.first_name"
                    :disabled="!enableEdit"
                    class="form-control"
                    name="first_name"
                    v-validate="'required'"
                    placeholder="First name"
                    :class="{'danger': errors.has('first name') }"
                  />
                </div>
              </div>
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label>Last Name</label>
                  <b-form-input
                    v-model="user.last_name"
                    :disabled="!enableEdit"
                    class="form-control"
                    name="last_name"
                    v-validate="'required'"
                    placeholder="Last name"
                    :class="{'danger': errors.has('last name') }"
                  />
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label>Gender</label>
                  <b-form-select
                    v-model="user.gender"
                    :disabled="!enableEdit"
                    v-validate="'required'"
                    :options="genderOptions"
                    :class="{'danger': errors.has('gender') }"
                    name="gender"
                  />
                </div>
              </div>
              <div class="col col-md-6 col-12">
                <v-date-picker
                  label="Date of birth"
                  :disabled="!enableEdit"
                  :maxDate="getFormattedDate(new Date())"
                  @onChange="value=> user.dob = value"
                  :value="defaultDateFormat(user.dob)"
                  v-validate="`required`"
                  :className="{'danger': errors.has('dob') }"
                  name="dob"
                  position="bottom"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-md-6 col-12">
                <b-form-group
                  label="Designation"
                  label-for="Designation"
                >
                  <div class="border-text">{{ user.designation === 'FIRST_RESPONDER' ? 'Initial Call Receiver' : user.designation | normalizetext}}</div>
                </b-form-group>
              </div>
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <v-mobile-input
                    :value="user.mobile_no"
                    v-model="user.mobile_no"
                    :disabled="!enableEdit"
                    :countryCode="user.country_code"
                    :label="`Mobile Number`"
                    v-validate="'required'"
                    :className="{'danger': errors.has('mobileNumber') }"
                    @onChange="onMobileInputChange"
                    name="mobileNumber"
                    type="number"
                    placeholder="Enter MobileNumber"
                  />
                  <span class="text-danger" v-if="!isMobileNumberValid"><small>The mobileNumber must be a valid mobile number</small></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <b-form-input
                    class="form-control"
                    placeholder="email"
                    v-validate="'required'"
                    :class="{'danger': errors.has('email') }"
                    v-model="user.email"
                    :disabled="!enableEdit"
                    name="email"
                  />
                </div>
              </div>
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <textarea
                    class="form-control"
                    placeholder="address"
                    v-validate="'required'"
                    v-model="user.address"
                    :disabled="!enableEdit"
                    :class="{'danger': errors.has('address') }"
                    row="5"
                    name="address"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <button
                  class="btn btn-primary float-right ml-2"
                  type="submit"
                  variant="primary"
                >
                  {{ enableEdit ? "Update" : "Edit Details" }}
                </button>
              </div>
            </div>
          </div>
        </form>
        
         <h5>Change Password</h5>
          <hr/>
        <form @submit.prevent="validateChangePassword">
           <div class="row">
              <div class="col col-6 p-0">
                  <div class="col-md-12">
                    <label>New Password</label>
                    <b-form-input
                      v-model="userPassword.password"
                      required
                      minlength="5"
                      class="form-control"
                      name="password"
                      placeholder="New Password"
                      :class="{'danger': errors.has('password') }"
                    />
                  </div>
                  <div class="col-md-12 mt-2">
                    <label>Confirm Password</label>
                    <b-form-input
                      class="form-control"
                      required
                      minlength="5"
                      v-model="userPassword.confirm"
                      name="confirm_password"
                      placeholder="Confirm Password"
                      :class="{'danger': errors.has('confirm_password') }"
                    />
                  </div>
                   <div class="col col-12 mt-2">
                    <button
                      class="btn btn-primary float-right ml-2"
                      type="submit"
                      variant="primary"
                    >
                      Change Password
                    </button>
                  </div>
              </div>
            </div>
        </form>
    </div></div>
      <b-modal 
      id="video-call"
      ref="passwordMismatch"
      size="md"
      centered
       hide-header
       hide-footer
      aria-label="Video Call"
      body-class="mh-100 p-0"
    >
        <div class="modal-header">
          <h4 class="modal-title text-left ">Change Password</h4>
        </div>
        <div class="modal-body">
          <p>Confirm Password does not match.</p>
        </div>
        <div class="modal-footer">
          <button type="button"  variant="outline-primary" class="btn btn-primary" @click="closeModal">Close</button>
        </div>
    </b-modal>
  </v-layout>
</template>


<script>
import { mapGetters } from 'vuex';
import VLayout from '@/layouts/Default.vue';
// import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VMobileInput from '@/components/baseComponents/BaseMobileInput.vue';
import roles from '@/constants/_roles';

export default {
  name: 'Profile',
  components: { VLayout, VMobileInput },
  data() {
    return {
      show: false,
      type: 'success',
      dismissible: false,
      enableEdit: false,
      dismissSecs: 1,
      isMobileNumberValid: true,
      dismissCountDown: 0,
      userPassword:{},
      text: '',
      variant: '',
      genderOptions: [{
        text: 'Choose a gender',
        value: null
      },
      {
        value: 'male',
        text: 'Male'
      },
      {
        value: 'female',
        text: 'Female'
      }],
      designations: [
        {
          value: null,
          text: 'Select a Role'
        },
        {
          value: roles.CARE_AUTHOR,
          text: 'Care Author'
        },
        {
          value: roles.CARE_NAVIGATOR,
          text: 'Care Navigator'
        },
        {
          value: roles.ADMIN,
          text: 'Admin'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/getUser',
      user: 'profile/getUser',
      status: 'profile/getStatus'
    })
  },
  watch: {
    currentUser: {
      handler: 'getUser',
      immediate: true
    },
    status(value) {
      if (value === 'success') {
        this.text = 'Profile updated successfully!';
        this.variant = 'success';
      } else if (value === 'danger') {
        this.text = 'Profile updation failed!';
        this.variant = 'danger';
      }
    }
  },
  methods: {
    getUser(value) {
      if (this.isNotEmpty(value)) {
        this.$store.dispatch('profile/view', value.id);
      }
    },
   onMobileInputChange({ isValid, country }, mobileNumber) {
      this.isMobileNumberValid = isValid;
      this.user.mobile_no = mobileNumber;
      this.user.country_code = country.dialCode;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.user.email = this.user.email.toLowerCase();
        const data = this.user;
        if (result && this.enableEdit && this.isMobileNumberValid) {
          this.$store.dispatch('profile/update', data);
          this.enableEdit = false;
        } else if (!this.enableEdit) {
          this.enableEdit = true;
        }
      });
    },
    closeModal(){
      this.$refs.passwordMismatch.hide();
    },
    validateChangePassword(){
       this.$validator.validateAll().then((result) => {
         if(this.userPassword.password !== this.userPassword.confirm){
           this.$refs.passwordMismatch.show();
           return false;
         }
        const data = {};
        data.password =  this.userPassword.password;
        if (result) {
          let passwordContent = {
            title: 'Change Password',
            message: 'Do you want to change your password?'
          };
           this.conFirmAlert(
              passwordContent,
              () => {
                 this.$store.dispatch('user/changePassword', data);
                 
              },
              () => {
                // cancel
              }
            );
         
        } 
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
